import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {labels} from '../../../../util/utils';
import {trialBalanceCategories, trialBalanceType} from '../../../../util/uiconstants';
import ContentSwitcher from '../../../Common/BaseComponentWrappers/MotifContentSwitcher';
import Button from '../../../Common/BaseComponentWrappers/MotifButton';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';

export default function OARSwitcher(props) {
	const {activeTab, onTabChange, trialBalanceCall} = props;

	const [showSwitcher, setShowSwitcher] = useState(false);

	useEffect(() => {
		const params = {
			trialBalanceTypeCategory: trialBalanceCategories.PriorPeriod,
			includeFinancialStatements: false,
			includeFinancialStatementAnnotations: false
		};

		trialBalanceCall(params).then((resp) => {
			if (resp.length > 0) {
				setShowSwitcher(true);
			}
		});
	}, []);

	const handleActiveClass = useCallback(
		(id) => {
			return activeTab === id ? 'motif-active' : '';
		},
		[activeTab]
	);

	return (
		<React.Fragment>
			{showSwitcher && (
				<ContentSwitcher>
					<Button
						onClick={() => onTabChange(trialBalanceType.Planning)}
						className={handleActiveClass(trialBalanceType.Planning)}
						type="button"
					>
						<EllipsesControl content={labels.currentYearBalance} tooltip={labels.currentYearBalance} noOfLines={1} />
					</Button>
					<Button
						onClick={() => onTabChange(trialBalanceType.PlanningPriorYear)}
						className={handleActiveClass(trialBalanceType.PlanningPriorYear)}
						type="button"
					>
						<EllipsesControl content={labels.priorPeriod} tooltip={labels.priorPeriod} noOfLines={1} />
					</Button>
				</ContentSwitcher>
			)}
		</React.Fragment>
	);
}

OARSwitcher.propTypes = {
	activeTab: PropTypes.string,
	onTabChange: PropTypes.func,
	trialBalanceCall: PropTypes.func
};
